import { render, staticRenderFns } from "./AdminAffiliatePromotionsListPage.vue?vue&type=template&id=ac1925d2&scoped=true"
import script from "./AdminAffiliatePromotionsListPage.vue?vue&type=script&lang=js"
export * from "./AdminAffiliatePromotionsListPage.vue?vue&type=script&lang=js"
import style0 from "./AdminAffiliatePromotionsListPage.vue?vue&type=style&index=0&id=ac1925d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1925d2",
  null
  
)

export default component.exports